var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { RebillyProvider } from './Rebilly';
import { BusinessProvider } from './Business';
import { CartProvider } from './Cart';
import { ShippingProvider } from './Shipping';
import { BillingProvider } from './Billing';
import { CardProvider } from './Card';
import { PaymentProvider } from './Payment';
import { SubmitProvider } from './Submit';
import { EmailProvider } from './Email';
import { BillingIsSameProvider } from './BillingIsSame';
import { ShowDetailsProvider } from './ShowDetails';
import { FramePay } from './FramePay';
import { TogglesProvider } from './Toggles';
import { CustomJsonProvider } from './CustomJson';
export * from './FramePay';
export * from './Rebilly';
export * from './Business';
export * from './Email';
export * from './Cart';
export * from './Card';
export * from './Payment';
export * from './Shipping';
export * from './Billing';
export * from './Form';
export * from './ShowDetails';
export var CheckoutProviders = function (_a) {
    var businessName = _a.businessName, businessLogo = _a.businessLogo, privacyLink = _a.privacyLink, termsLink = _a.termsLink, items = _a.items, shipping = _a.shipping, children = _a.children, rebillyType = _a.rebillyType, framePayEnabled = _a.framePayEnabled, requiredToggles = _a.requiredToggles, onContactInfoCompleted = _a.onContactInfoCompleted, onShippingInfoCompleted = _a.onShippingInfoCompleted, onBillingInfoCompleted = _a.onBillingInfoCompleted, onPaymentInfoCompleted = _a.onPaymentInfoCompleted, getCustomJson = _a.getCustomJson, customJson = _a.customJson, appearing = _a.appearing, props = __rest(_a, ["businessName", "businessLogo", "privacyLink", "termsLink", "items", "shipping", "children", "rebillyType", "framePayEnabled", "requiredToggles", "onContactInfoCompleted", "onShippingInfoCompleted", "onBillingInfoCompleted", "onPaymentInfoCompleted", "getCustomJson", "customJson", "appearing"]);
    return (_jsx(RebillyProvider, __assign({ rebillyType: rebillyType }, { children: _jsx(BusinessProvider, __assign({ businessName: businessName, businessLogo: businessLogo, privacyLink: privacyLink, termsLink: termsLink }, { children: _jsx(CartProvider, __assign({ items: items, shipping: shipping }, { children: _jsx(ShowDetailsProvider, { children: _jsx(BillingIsSameProvider, { children: _jsx(EmailProvider, __assign({ onCompleted: onContactInfoCompleted }, { children: _jsx(ShippingProvider, __assign({ onCompleted: onShippingInfoCompleted }, { children: _jsx(BillingProvider, __assign({ onCompleted: onBillingInfoCompleted }, { children: _jsx(CardProvider, __assign({ onCompleted: onPaymentInfoCompleted }, { children: _jsx(TogglesProvider, __assign({ requiredToggles: requiredToggles }, { children: _jsx(PaymentProvider, __assign({ appearing: appearing }, { children: _jsx(CustomJsonProvider, __assign({ getCustomJson: getCustomJson, customJson: customJson }, { children: _jsx(SubmitProvider, __assign({}, props, { children: _jsx(FramePay, __assign({ framePayEnabled: framePayEnabled }, { children: children })) })) })) })) })) })) })) })) })) }) }) })) })) })));
};
//# sourceMappingURL=index.js.map